import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { ACCOUNT_ADMIN_PAGE_NAME } from '../../../constants/service/app/accountAdminConstants';
import AccountAdminTable from '../../../views/account/admin/list/AccountAdminTable';
import FullscreenLoader from '../../../components/base/FullscreenLoader';
import useReactTable from '../../../hooks/common/useReactTable';
import { useAccountAdminList } from '../../../views/account/admin/common/hook/query/useAccountAdminList';
import {
  ACCOUNT_ADMIN_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_ADMIN_LIST_PAGINATION_MODEL,
  ACCOUNT_ADMIN_LIST_SORT_OPTION_MODEL,
} from '../../../views/account/admin/common/constants';

const AccountAdminList = (): JSX.Element => {
  const {
    filterOption,
    paginationOption,
    sortOption,
    handleChangeFilterOption,
    handleChangePaginationOption,
    handleClickSortOption,
    handleClickResetFilter,
    currentPage,
    setCurrentPage,
  } = useReactTable({
    filterOptionModel: ACCOUNT_ADMIN_LIST_FILTER_OPTION_MODEL,
    sortOptionModel: ACCOUNT_ADMIN_LIST_SORT_OPTION_MODEL,
    paginationModel: ACCOUNT_ADMIN_LIST_PAGINATION_MODEL,
  });

  const { data: accountAdminList, isLoading } = useAccountAdminList({
    page: Math.max(paginationOption.pageIndex, 1),
    pageSize: Math.max(paginationOption.pageSize, 100),
    ...filterOption,
  });

  if (isLoading) {
    return <FullscreenLoader visible={true} />;
  }

  return (
    <PageTemplate pageName={ACCOUNT_ADMIN_PAGE_NAME.ADMIN_LIST}>
      {/* 관리자 리스트 */}
      <AccountAdminTable
        accountAdminList={accountAdminList}
        onChangeFilterOption={handleChangeFilterOption}
        onChangePaginationOption={handleChangePaginationOption}
        onClickSortOption={handleClickSortOption}
        paginationOption={paginationOption}
        sortOption={sortOption}
        handleClickResetFilter={handleClickResetFilter}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </PageTemplate>
  );
};

export default AccountAdminList;
